import { render, staticRenderFns } from "./DragableSort.vue?vue&type=template&id=20a6de91&scoped=true&"
import script from "./DragableSort.vue?vue&type=script&lang=js&"
export * from "./DragableSort.vue?vue&type=script&lang=js&"
import style0 from "./DragableSort.vue?vue&type=style&index=0&id=20a6de91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a6de91",
  null
  
)

export default component.exports